import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { rollDice, setDataGame } from './game';
import { catchError, setData } from './main';
import { setMsg, toggleError, toggleModal } from './modal';
import copy from 'copy-to-clipboard';

export const getUserInfo = () => {
	return (dispatch) => {
		trackPromise(
			axios
				.get('oauth/check_login/')
				.then((resp) => {
					dispatch(setData('isLogin', true));
					dispatch(setData('accountId', resp.data.user.account_id));
					dispatch(setDataGame('lap', resp.data.laps));
					dispatch(setDataGame('position', resp.data.last_position));

					dispatch(getMilestone());
					dispatch(getExchangeToken());
					dispatch(getSpinToken());
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

export const getExchangeToken = () => {
	return (dispatch) => {
		trackPromise(
			axios
				.get('api/exchange_token/')
				.then((resp) => {
					dispatch(setData('exchangeToken', resp.data.exchange_token));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

export const getSpinToken = () => {
	return (dispatch) => {
		trackPromise(
			axios
				.get('api/spin_token/')
				.then((resp) => {
					dispatch(setData('spinToken', resp.data.spin_token));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

export const spinDice = () => {
	return (dispatch) => {
		dispatch(toggleModal('ModalConfirm', false));
		trackPromise(
			axios
				.post('api/spin/')
				.then((resp) => {
					let PRIZE = {
						item_name: 'exchange_token',
						item_count: 5,
						item_image: process.env.REACT_APP_CDN_URL + 'ico_exchange_token.png',
					};
					const dice = resp.data.dice_count;
					if (resp.data.action !== 'start') PRIZE = resp.data;
					dispatch(setData('prize', PRIZE));
					dispatch(getSpinToken());
					dispatch(getExchangeToken());
					dispatch(rollDice(dice));
					dispatch(setData('fetchHistories', true));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

/** MILESTONE */

export const getMilestone = () => {
	return (dispatch) => {
		trackPromise(
			axios
				.get('api/milestone/')
				.then((resp) => {
					dispatch(setData('milestones', resp.data.milestone));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

export const claimMilestone = (id) => {
	return (dispatch) => {
		trackPromise(
			axios
				.post('api/milestone/', { milestone_id: id })
				.then((resp) => {
					dispatch(getMilestone());
					dispatch(setData('prize', resp.data));
					dispatch(toggleModal('ModalPrize', true));
					dispatch(setData('fetchHistories', true));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};

/** CODE */

export const claimCode = (code) => {
	return (dispatch) => {
		trackPromise(
			axios
				.post('api/claim_code/', { code })
				.then((resp) => {
					dispatch(setMsg('claim_code_successfully'));
					dispatch(setData('nickname', resp.data.user_name));
					dispatch(toggleError(false));
					dispatch(toggleModal('ModalMessage', true));
					dispatch(setData('fetchHistories', true));
				})
				.catch((err) => {
					dispatch(setMsg(err.msg));
				})
		);
	};
};

export const shareCode = (type, cb) => {
	return (dispatch) => {
        trackPromise(
            axios
            .post('api/share/')
            .then((resp) => {
                    /** Remove the hashtag */
                    const baseurl = process.env.REACT_APP_BASE_URL.slice(0, -1);
                    const uri = `${baseurl}share.html?code=${resp.data.code}`;
					const appId = '449379502491673';
                    dispatch(setData('fetchHistories', true));
					if (type === 'fb') {
						let url =
							'https://www.facebook.com/dialog/share?' +
							'app_id=' +
							appId +
							'&display=touch' +
							'&href=' +
							encodeURIComponent(baseurl) +
							`share.html?code=${resp.data.code}` +
							'&redirect_uri=' +
							encodeURIComponent(baseurl) + 'run';
						window.location.href = url;
					} else if (type === 'wa') {
						let url =
							'https://api.whatsapp.com/send/?phone' +
							'&text=' +
							encodeURIComponent(baseurl) +
							`share.html?code=${resp.data.code}`;
						window.location.href = url;
					} else if (type === 'line') {
						let url =
							'https://social-plugins.line.me/lineit/share?url=' +
							encodeURIComponent(`${baseurl}/share.html?code=${resp.data.code}`) +
                            `&text=Garena Free Fire - Master League Season IV`;
						window.location.href = url;
					} else {
                        copy(uri);
                        cb();
                    }
				})
				.catch((err) => {
                    console.log(err);
					dispatch(catchError(err));
				})
		);
	};
};

/** HISTORY */

export const history = () => {
	return (dispatch) => {
		trackPromise(
			axios
				.get('api/history/')
				.then((resp) => {
					dispatch(setData('histories', resp.data.history_list));
					dispatch(setData('fetchHistories', false));
				})
				.catch((err) => {
					dispatch(catchError(err));
				})
		);
	};
};
